import { Route, Routes, Navigate } from "react-router-dom";

import { authRouter, publicRouter } from "./Routes/router";
import { ProtectedRoute, GetLocalStorage } from "./HigherOrderComponent";
import Master from "./Layouts/Master";

const App = () => {
  return (
    <Routes>
      <Route element={<ProtectedRoute />}>
        <Route element={<Master />}>
          {authRouter.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={<route.component />}
            />
          ))}
        </Route>
      </Route>

      <Route element={<GetLocalStorage />}>
        {publicRouter.map((route, index) => (
          <Route key={index} path={route.path} element={<route.component />} />
        ))}
      </Route>

      <Route path="*" element={<Navigate to="/live-market" />} />
    </Routes>
  );
};

export default App;
